import {
  ABREVIATURAS_PADRAO,
  CATALOGO_NORMAS,
  CATALOGO_PRECAUCOES,
  CATALOGO_USOS_PROIBIDOS,
  FALHAS_PADRAO,
  GLOSSARIO_PADRAO,
  PLANO_MANUTENCAO_PADRAO,
} from './manual-catalogos';
import { TEXTOS } from './manual-textos';
import { novoId } from './manual-utils';
import type {
  ItemChamada,
  ItemComando,
  ItemEmergencia,
  ItemEnergia,
  ItemEspecificacao,
  ItemEtapa,
  ItemFalha,
  ItemFuncaoSeguranca,
  ItemGlossario,
  ItemLubrificacao,
  ItemManutencao,
  ItemNorma,
  ItemPerigo,
  ItemSinalizacao,
  ItemTexto,
  ItemVista,
  ManualData,
  ManualOpcoes,
  SecaoDef,
} from './manual-types';

export const OPCOES_PADRAO: ManualOpcoes = {
  tituloDocumento: 'MANUAL DE INSTRUÇÕES RECONSTITUÍDO',
  reconstituidora: 'Schmersal Brasil',
  site: 'www.schmersal.com.br',
  avisoLegal: TEXTOS.avisoLegal,
  numerarPaginas: true,
  incluirSumario: true,
  incluirSimbologia: true,
  incluirNormas: true,
  incluirEspecEletricas: true,
  incluirEspecHidraulicas: false,
  incluirEspecPneumaticas: false,
  incluirLubrificacao: false,
  incluirUsoImprevisivel: true,
  incluirAssistencia: true,
  incluirGlossario: true,
  incluirAbreviaturas: true,
  densidadeTexto: 100,
};

export const DADOS_PADRAO: ManualData = {
  nomeMaquina: '',
  identificacao: '',
  modeloTipo: '',
  numeroSerie: '',
  anoFabricacao: '',
  codigoRastreabilidade: '',
  versao: '0',
  dataEmissao: '',
  dataLevantamento: '',
  localLevantamento: '',
  responsavelLevantamento: '',
  fabricante: '',
  fabricanteContato: '',
  contratante: '',
  contratanteUnidade: '',
  setor: '',
  imagemCapa: null,
  documentosConsultados: [],
  publicoAlvo: [],
  normas: [],

  usoDevido: '',
  usosProibidos: [],
  precaucoes: [],
  epcs: [],
  epis: [],
  treinamentos: [],
  sinalizacao: [],
  energias: [],
  conexaoEnergia: TEXTOS.conexaoEnergia,
  desconexaoEnergia: TEXTOS.desconexaoEnergia,
  funcoesSeguranca: [],
  perigos: [],
  emergencias: [],

  descricao: '',
  aplicacao: '',
  principioFuncionamento: '',
  capacidade: '',
  dimensoes: '',
  peso: '',
  tensao: '',
  vistas: [],
  especGerais: [],
  especEletricas: [],
  especHidraulicas: [],
  especPneumaticas: [],

  transporte: TEXTOS.transporte,
  armazenagem: TEXTOS.armazenagem,
  montagem: TEXTOS.instalacao,
  icamento: TEXTOS.icamento,
  ajustes: TEXTOS.ajustes,
  requisitosLocal: [],
  assistencia: TEXTOS.assistencia,
  assistenciaContato: '',

  apresentacaoOperacao: TEXTOS.operacaoIntro,
  imagemComandos: null,
  comandos: [],
  preparacao: [],
  operacao: [],
  parada: [],
  emergenciaEtapas: [],
  usosImprevisiveis: [],

  orientacaoManutencao: TEXTOS.manutencaoIntro,
  planoManutencao: [],
  lubrificacao: [],
  limpeza: [],
  falhas: [],

  desativacao: TEXTOS.desativacao,
  desmontagem: TEXTOS.desmontagem,
  descarte: TEXTOS.descarte,

  glossario: [],
  abreviaturas: [],

  opcoes: OPCOES_PADRAO,
};

/** Fábricas de itens vazios para as listas dinâmicas. */
export const novoTexto = (texto = ''): ItemTexto => ({ id: novoId('txt'), texto });
export const novaNorma = (base: Partial<ItemNorma> = {}): ItemNorma => ({ id: novoId('nrm'), codigo: '', titulo: '', ano: '', ...base });
export const novaSinalizacao = (): ItemSinalizacao => ({ id: novoId('sin'), tipo: '', local: '', significado: '' });
export const novaEnergia = (base: Partial<ItemEnergia> = {}): ItemEnergia => ({ id: novoId('eng'), tipo: '', especificacao: '', ponto: '', desconexao: '', ...base });
export const novaFuncaoSeguranca = (): ItemFuncaoSeguranca => ({ id: novoId('fsg'), denominacao: '', componente: '', categoria: '', descricao: '' });
export const novoPerigo = (): ItemPerigo => ({ id: novoId('per'), local: '', fonte: '', perigo: '', classe: 'dissociavel', protecao: '' });
export const novaEmergencia = (): ItemEmergencia => ({ id: novoId('emg'), situacao: '', acao: '' });
export const novaChamada = (numero = '', base: Partial<ItemChamada> = {}): ItemChamada => ({ id: novoId('cha'), numero, descricao: '', ...base });
export const novaVista = (titulo = ''): ItemVista => ({ id: novoId('vst'), titulo, legenda: '', imagem: null, chamadas: [] });
export const novaEspecificacao = (base: Partial<ItemEspecificacao> = {}): ItemEspecificacao => ({ id: novoId('esp'), item: '', valor: '', unidade: '', ...base });
export const novoComando = (base: Partial<ItemComando> = {}): ItemComando => ({ id: novoId('cmd'), identificacao: '', tipo: '', funcao: '', local: '', ...base });
export const novaManutencaoDe = (base: Omit<ItemManutencao, 'id'>): ItemManutencao => ({ id: novoId('mnt'), ...base });
export const novaFalhaDe = (base: Omit<ItemFalha, 'id'>): ItemFalha => ({ id: novoId('flh'), ...base });
export const novaEtapa = (): ItemEtapa => ({ id: novoId('etp'), descricao: '', observacao: '' });
export const novaManutencao = (): ItemManutencao => ({ id: novoId('mnt'), parte: '', tarefa: '', metodo: '', periodicidade: '', responsavel: '' });
export const novaLubrificacao = (): ItemLubrificacao => ({ id: novoId('lub'), ponto: '', produto: '', quantidade: '', periodicidade: '' });
export const novaFalha = (): ItemFalha => ({ id: novoId('flh'), falha: '', causa: '', solucao: '' });
export const novoGlossario = (base: Partial<ItemGlossario> = {}): ItemGlossario => ({ id: novoId('glo'), termo: '', definicao: '', ...base });

export const SECOES: SecaoDef[] = [
  { id: '01', titulo: 'Identificação', descricao: 'Dados da máquina, levantamento, normas e público-alvo' },
  { id: '02', titulo: 'Segurança', descricao: 'Uso devido, proteções, energias, perigos e emergências' },
  { id: '03', titulo: 'Visão geral', descricao: 'Descrição, vistas, chamadas e especificações técnicas' },
  { id: '04', titulo: 'Instalação', descricao: 'Transporte, armazenagem, montagem, içamento e ajustes' },
  { id: '05', titulo: 'Operação', descricao: 'Comandos, preparação, operação, parada e emergência' },
  { id: '06', titulo: 'Manutenção', descricao: 'Plano, lubrificação, limpeza e lista de falhas' },
  { id: '07', titulo: 'Encerramento', descricao: 'Desativação, desmontagem, descarte e glossário' },
  { id: '08', titulo: 'Documento', descricao: 'Opções de composição, revisão e exportação' },
];

/**
 * Conteúdo que é igual em todo manual reconstituído: normas de referência,
 * precauções gerais, usos indevidos, glossário e abreviaturas. Nasce preenchido
 * porque é texto do template, não levantamento de campo — o que é da máquina
 * (EPC, funções de segurança, perigos, vistas) continua começando vazio, para
 * ninguém publicar proteção que a máquina não tem.
 *
 * Plano de manutenção e lista de falhas também nascem cheios, mas pelo motivo
 * inverso: o modelo é enxuto e genérico, e o trabalho de campo é APAGAR a linha
 * que não se aplica àquela máquina (e acrescentar o que faltar), não redigir
 * tudo do zero. Ver `PLANO_MANUTENCAO_PADRAO` e `FALHAS_PADRAO`.
 *
 * Os itens são criados a cada chamada: ids repetidos entre manuais confundiriam
 * o editor e o histórico.
 */
function listasPadrao(): Pick<ManualData, 'normas' | 'precaucoes' | 'usosProibidos' | 'glossario' | 'abreviaturas' | 'planoManutencao' | 'falhas'> {
  const NORMAS_BASE = ['NR-12', 'ABNT NBR ISO 12100', 'ABNT NBR 16746'];
  return {
    normas: CATALOGO_NORMAS
      .filter((norma) => NORMAS_BASE.includes(norma.codigo))
      .map((norma) => novaNorma(norma)),
    precaucoes: CATALOGO_PRECAUCOES.map((texto) => novoTexto(texto)),
    usosProibidos: CATALOGO_USOS_PROIBIDOS.map((texto) => novoTexto(texto)),
    glossario: GLOSSARIO_PADRAO.map((item) => novoGlossario(item)),
    abreviaturas: ABREVIATURAS_PADRAO.map((item) => novoGlossario(item)),
    planoManutencao: planoManutencaoPadrao(),
    falhas: falhasPadrao(),
  };
}

/** Linhas do plano de manutenção do modelo, com ids novos. */
export function planoManutencaoPadrao(): ItemManutencao[] {
  return PLANO_MANUTENCAO_PADRAO.map((item) => novaManutencaoDe(item));
}

/** Linhas da lista de falhas do modelo, com ids novos. */
export function falhasPadrao(): ItemFalha[] {
  return FALHAS_PADRAO.map((item) => novaFalhaDe(item));
}

/** Estado de um manual novo: textos padrão já aplicados e data de hoje. */
export function dadosIniciais(): ManualData {
  return {
    ...DADOS_PADRAO,
    ...listasPadrao(),
    dataEmissao: new Date().toISOString().slice(0, 10),
  };
}
